import { useSelector } from 'react-redux';
import { selectConnectWorkstations } from '../store/shipstation-connect/ss-connect.selectors';
import { emptyArray } from 'ui-components/default-props/empty';

export const useWorkstations = () => {
  return useSelector(selectConnectWorkstations) || emptyArray;
};
